import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Highlights from "@/components/landing/Highlights";
import Tours from "@/components/landing/Tours";
import CustomTour from "@/components/landing/CustomTour";
import SuggestPlace from "@/components/landing/SuggestPlace";
import About from "@/components/landing/About";
import HowItWorks from "@/components/landing/HowItWorks";
import PaymentInfo from "@/components/landing/PaymentInfo";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";
import FloatingWhatsApp from "@/components/landing/FloatingWhatsApp";

export default function Landing() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Highlights />
        <Tours />
        <CustomTour />
        <SuggestPlace />
        <About />
        <HowItWorks />
        <PaymentInfo />
        <Faq />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </>
  );
}
